import React, { Component } from 'react'
import { Modal, Tabs, Image, Table, Row, Col, Button } from 'antd';
import { prUrl, osintRequestAddress } from '../config.js'
import KnowledgeGraph from '../KnowledgeGraph'
import TrackMap from './TrackMap'
import News from '../News'
import ShipStatus from './ShipStatus'
import ShipActivities from './ShipActivities.jsx';
import { Tweets, SatImgTweets } from '../Tweets'
import { cordConvert } from '../../utils'
import axios from 'axios';
import ShipAniTrackMap from './ShipAniTrackMap.jsx';

const { TabPane } = Tabs;

const infoBoxCcolumns = [
    {
        title: '属性项',
        dataIndex: 'label',
        key: 'label',
        width: '30%',
        align: 'center',
    },
    {
        title: '属性值',
        dataIndex: 'value',
        key: 'value',
    },
]

export default class ShipDetails extends Component {
    state = {
        shipEvents: [],
        infobox: [],
        wiki: {},
        kgData: [],
        engNewsList: [],
        chnNewsList: [],
        twimages: [],
        tweets: [],
    }

    componentDidMount() {
        const { ship } = this.props
        this.sendShipRequests(ship)
    }

    sendShipRequests = (ship) => {
        if (ship.qcode) {
            // 获取舰船动态
            axios.get(`${osintRequestAddress}/ship?qcode=` + ship.qcode).then(
                response => {
                    if (response.data.events.length > 0) {
                        this.setState({
                            shipEvents: response.data.events
                        })
                    }
                },
                error => { console.log("error", error) }
            )
            // 获取关系wiki，图谱和infobox
            axios.get(`${osintRequestAddress}/kg?content=nri&qcode=` + ship.qcode).then(
                response => {
                    if (response.data && response.data.wikipedia && response.data.relatedNodes && response.data.infobox && response.data.wikipedia.length > 0) {
                        this.setState({
                            wiki: response.data.wikipedia[0],
                            kgData: response.data.relatedNodes,
                            infobox: response.data.infobox,
                        })
                    }
                },
                error => { console.log("error", error) }
            )
        }
        axios.get(`${osintRequestAddress}/search?engine=googlenews&byapp=true&keyword=` + ship.engName.replace(".", "").replace(" ", "")).then(
            response => {
                if (response.data) {
                    this.setState({
                        engNewsList: response.data.results
                    })
                }
            },
            error => { console.log("error", error) }
        )
        axios.get(`${osintRequestAddress}/search?engine=googlenews&byapp=true&keyword=` + ship.shipName.split(" ")[1]).then(
            response => {
                if (response.data) {
                    this.setState({
                        chnNewsList: response.data.results
                    })
                }
            },
            error => { console.log("error", error) }
        )
        axios.get(`${osintRequestAddress}/twimage?shipnum=` + ship.shipNum).then(
            response => {
                if (response.data) {
                    this.setState({
                        twimages: response.data
                    })
                }
            },
            error => { console.log("error", error) }
        )
        axios.get(`${osintRequestAddress}/tweets?keyword=%23` + ship.engName.replace(".", "").replace(" ", "")).then(
            response => {
                var tweetsSet = new Set();
                if (response.data) {
                    response.data.map((tweet) =>
                        tweetsSet.add(tweet)
                    )
                }
                axios.get(`${osintRequestAddress}/tweets?keyword=` + ship.engName).then(
                    response => {
                        if (response.data) {
                            response.data.map((tweet) =>
                                tweetsSet.add(tweet)
                            )
                        }
                        this.setState({
                            tweets: Array.from(tweetsSet)
                        })
                    },
                    error => { console.log("error", error) }
                )
            },
            error => { console.log("error", error) }
        )
    }

    render() {
        const { ship } = this.props
        const titleText = ship.shipName + " (最新位置：" + ship.startTime + "位" + cordConvert(ship.lat, ship.lon) + ")"
        return (
            <Modal key={ship ? ship.shipNum : null} title={titleText} maskClosable={false} width={'70vw'} visible={this.props.isModalOpen} onCancel={this.props.handleModalShow}
                footer={[<Button key="close" type="primary" onClick={this.props.handleModalShow}>关闭</Button>]}>
                <Tabs key={ship.qcode} defaultActiveKey="1">
                    <TabPane tab="最新动态" key="1">
                        <ShipActivities events={this.state.shipEvents.slice(0, 12)} />
                    </TabPane>
                    <TabPane tab="活动轨迹" key="2">
                        <TrackMap qcode={ship.qcode} events={this.state.shipEvents.slice(0, 12)} />
                    </TabPane>
                    <TabPane tab="动画轨迹" key="99">
                        <ShipAniTrackMap qcode={ship.qcode} events={this.state.shipEvents.slice(0, 12)} />
                    </TabPane>
                    <TabPane tab="新闻报道" key="3">
                        <News engNewsList={this.state.engNewsList} chnNewsList={this.state.chnNewsList} />
                    </TabPane>
                    <TabPane tab="社媒言论" key="4">
                        <Tweets tweets={this.state.tweets} />
                    </TabPane>
                    <TabPane tab="基础资料" key="5">
                        <Row align='middle' justify='center'>
                            <Col span={12} >
                                <Row align='middle' justify='center'><Image src={prUrl + this.state.wiki.imageurl} preview={false} width='30vw' /></Row>
                            </Col>
                            <Col span={12}>
                                <Table columns={infoBoxCcolumns} showHeader={false} dataSource={this.state.infobox} size="small" pagination={{ hideOnSinglePage: true }}></Table>
                            </Col>
                        </Row>
                    </TabPane>
                    <TabPane tab="关系图谱" key="6">
                        <KnowledgeGraph kgData={this.state.kgData} wikiWord={this.state.wiki} />
                    </TabPane>
                    <TabPane tab="影像追踪" key="7">
                        <SatImgTweets twimages={this.state.twimages} />
                    </TabPane>
                    <TabPane tab="舰船状态" key="8">
                        <ShipStatus shipNum={ship.shipNum} shipEvents={this.state.shipEvents} />
                    </TabPane>
                    <TabPane tab="主要人员" key="9">本模块未展示……</TabPane>
                    <TabPane tab="社会活动" key="10">本模块未展示……</TabPane>
                </Tabs>
            </Modal>
        )
    }
}
